import { Box, Card, Tooltip, Typography } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PlatformSalesIcon from '../PlatformSalesIcon';
import useStyles from './styles';
import { Clock } from 'react-feather';
import { zerosEsquerda } from 'src/utils/getUtils';
import moment from 'moment';
import { formatData, formatDataHora, formatDataHoraMinuto } from 'src/utils/dateUtils';
import ShippingStatusIcon from '../ShippingStatusIcon';
import { getPendingStatus } from 'src/utils/systemUtils';
import FlatIcon, { FlatIconOptions } from 'src/components/ui/FlatIcon';

function SalesOrderCard({ hideId = false, orders = [] }) {
  const classes = useStyles();
  const smallText = { fontSize: '11px', lineHeight: '11px' };
  const labelText = { fontSize: '12px', lineHeight: '12px' };

  function diffHours(data1, data2) {
    let dif =
      Date.UTC(data1.getYear(), data1.getMonth(), data1.getDate(), 0, 0, 0) -
      Date.UTC(data2.getYear(), data2.getMonth(), data2.getDate(), 0, 0, 0);

    dif = Math.abs(dif / 1000 / 60 / 60);
    let difH = Math.abs(data2.getHours() - data1.getHours());
    let difM = Math.abs(data2.getMinutes() - data1.getMinutes());

    return `${zerosEsquerda(dif + difH, 2)}:${zerosEsquerda(difM, 2)}`;
  }

  const CardSeparator = ({ hide }) => (
    <span
      className={classes.separator}
      style={{ backgroundColor: !hide ? 'rgba(61,61,61, 0.1)' : undefined }}
    />
  );

  const ItemCard = ({ item, key }) => (
    <Card
      key={item.order_id}
      className={classes.cardRowStyle}
      sx={{ mt: 1 }}>
      {/* Marketplace */}
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 300 }}>
        <PlatformSalesIcon
          platform={item?.marketplace?.name?.split('_')[0]?.toLowerCase()}
          width={35}
          height={35}
        />
        <Box sx={{ px: 1 }}>
          <Typography
            className={classes.itemLista}
            sx={labelText}>
            {item?.marketplace?.name}
          </Typography>
          <Typography
            className={classes.itemLista}
            sx={labelText}>
            {item?.shipping?.method_name}
          </Typography>
        </Box>
      </Box>
      <CardSeparator />

      {/* Pedido */}
      {!hideId && (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minWidth: item.prioritized ? 300 : 320,
            }}>
            <Tooltip title='Código do pedido'>
              <Typography
                className={classes.itemLista}
                align='left'
                sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px' }}>
                {item.order_id}
              </Typography>
            </Tooltip>
            <Tooltip title='Código do pedido do marketplace'>
              <Typography sx={{ fontSize: '14px', lineHeight: '14px', marginBottom: '1px' }}>
                {item?.order_id_marketplace}
              </Typography>
            </Tooltip>
            <Tooltip title='Data/Hora de aprovação do pedido'>
              <Typography
                className={classes.itemLista}
                align='left'
                sx={smallText}>
                {formatDataHoraMinuto(item?.approved_at)}
              </Typography>
            </Tooltip>
          </Box>
          {item?.prioritized && (
            <Tooltip title='Priorizado na expedição'>
              <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                <FlatIcon
                  icon={FlatIconOptions.priority}
                  size={16}
                  style={{ marginLeft: 'auto' }}
                />
              </Box>
            </Tooltip>
          )}
          <CardSeparator />
        </>
      )}

      {/* Separação*/}
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: 400 }}>
        <Tooltip title='Usuário separando o pedido'>
          <Typography
            align='left'
            sx={{ fontSize: '16px', lineHeight: '16px' }}>
            {item?.picking_info?.current_user}
          </Typography>
        </Tooltip>
        <Tooltip title='Data/Hora início separação'>
          <Typography sx={smallText}>{formatDataHora(item?.picking_info?.started_at)}</Typography>
        </Tooltip>
      </Box>
      <CardSeparator />

      {/* Enviar até */}
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
        <Typography
          align='left'
          sx={{ fontSize: '16px', lineHeight: '16px', marginBottom: '1px' }}>
          {formatData(item?.shipping?.estimated_handling_limit)}
        </Typography>
        <ShippingStatusIcon
          status={getPendingStatus(item?.shipping?.estimated_handling_limit)}
          style={{
            marginLeft: 1,
            marginRight: 1,
          }}
        />
      </Box>
      <CardSeparator />
    </Card>
  );

  return (
    <Box
      sx={{
        height: 'auto',
      }}>
      {/* Cabeçalho */}
      <Box
        className={classes.cardRowStyle}
        sx={{
          height: 40,
          backgroundColor: '#31b7bc',
          color: '#FFF',
          borderBottom: '3px solid rgb(0, 36, 47)',
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        }}>
        <Typography sx={{ minWidth: 300 }}>Marketplace</Typography>
        <CardSeparator hide />

        {!hideId && (
          <>
            <Typography sx={{ minWidth: 320 }}>Pedido</Typography>
            <CardSeparator hide />
          </>
        )}

        <Typography sx={{ minWidth: 400 }}>Separação</Typography>
        <CardSeparator hide />

        <Typography sx={{ width: '100%' }}>Enviar até</Typography>
        <CardSeparator hide />
      </Box>

      {/* Lista de pedidos */}
      <PerfectScrollbar
        style={{
          maxHeight: 'calc(100% - 40px)',
        }}>
        {orders.length > 0 ?
          orders.map((item, index) => (
            <ItemCard
              item={item}
              key={index}
            />
          ))
        : <ItemCard
            item={orders}
            key={1}
          />
        }
      </PerfectScrollbar>
    </Box>
  );
}

export default SalesOrderCard;
